import { createSelector } from "@reduxjs/toolkit";

export const selectUserState = (state) => state.user;

export const selectCommonUserInfo = createSelector(
    [selectUserState],
    (userState) => ({
        userId: userState.userId,
        name: userState.name,
        email: userState.email,
        isActive: userState.isActive,
        hasCredentials: userState.hasCredentials,
        profilePhotoUrl: userState.profilePhotoUrl,
    })
);

export const selectUserData = createSelector(
    [selectUserState],
    (userState) => userState.userData
);

export const selectAdminData = createSelector(
    [selectUserState],
    (userState) => userState.adminData
);

export const selectUserCafeId = createSelector(
    [selectUserData],
    (userData) => userData?.cafeId ?? null
);

export const selectAdminChecklistId = createSelector(
    [selectAdminData],
    (adminData) => adminData?.checklistId ?? null
);

export const selectAdminCafes = createSelector(
    [selectAdminData],
    (adminData) => adminData?.cafes ?? []
);

export const selectAdminCafesCount = createSelector(
    [selectAdminCafes],
    (cafes) => cafes.length
);

export const selectIsUserLoaded = createSelector(
    [selectUserState],
    (userState) => Boolean(userState.loaded)
);
